var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('template-card', {
    ref: "templateCard",
    attrs: {
      "partnerId": _vm.partnerId,
      "from": [_vm.partner],
      "context": _vm.context,
      "to": _vm.to,
      "refs": _vm.refs,
      "isTicketEnabled": _vm.isTicketEnabled,
      "attachmentFileFilters": _vm.attachmentFileFilters
    },
    on: {
      "sent": function sent(v) {
        return _vm.$emit('sent', v);
      },
      "isValid": function isValid($event) {
        return _vm.$emit('isValid', $event);
      }
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }